import React from 'react';

function BogusQuestion() {
  // eslint-disable-next-line
  return <div>BOGUS QUESTION</div>;
}

export const ChildrenAgesQuestion = BogusQuestion;
export const BreedQuestion = BogusQuestion;
export const BreedPreferenceDescriptionQuestion = BogusQuestion;
export const BreedSizePreferenceQuestion = BogusQuestion;
export const DeliveryPreferencesQuestion = BogusQuestion;
export const ProfilePhotoQuestion = BogusQuestion;
export const GoodDogPayPreferenceQuestion = BogusQuestion;
